module.exports = __webpack_public_path__ + "img/necromunda-map-main.3a33250c.png";